'use client';

import useMap from './useMap';

type Props = {
  places?: Partial<Place>[];
  theme?: string;
  zoom?: number;
};

const StaticMap = ({places, theme = 'light', zoom}: Props) => {
  const {mapContainer} = useMap({
    variant: 'places',
    places,
    themeOverride: theme === 'dark' ? 'dark' : 'light',
    zoomOverride: zoom
  });

  return (
    <div className="absolute top-0 right-0 bottom-0 left-0 [&_.mapboxgl-control-container]:hidden">
      <div ref={mapContainer} className="w-full h-full" />
    </div>
  );
};

export default StaticMap;
